const modules = [
  {
    icon: 'language',
    name: 'organization',
    path: '/organization',
  },
  {
    icon: 'credit_card',
    name: 'sales',
    path: '/sales',
  },
  {
    icon: 'settings',
    name: 'operations',
    path: '/operations',
  },
  {
    icon: 'swap_vert',
    name: 'utilities',
    path: '/utilities',
  },
  {
    icon: 'attach_money',
    name: 'cashOffice',
    path: '/cash-office',
  },
  {
    icon: 'receipt_long',
    name: 'jarvisSelfCheckout',
    path: '/branding',
  },
];

export default modules;
